export default __webpack_public_path__ + "static/hero_mainShort-9feaaddcc290f191f6380169f7a696d8.jpg";